import request from '@/utils/request'

// 统计页面统计
// http://192.168.1.199:5000/admin/statistics/daily
export function daily (data) {
    return request({
        url: 'statistics/daily',
        method: 'get',
        params: data
    })
}
// http://192.168.1.199:5000/admin/statistics/daily_list
//统计页新统计接口
export function daily_list (data) {
    return request({
        url: 'statistics/daily_list',
        method: 'get',
        params: data
    })
}
//统计页新统计接口
export function daily_list_best (data) {
    return request({
        url: 'statistics/daily_list_best',
        method: 'get',
        params: data
    })
}
//统计页新统计接口
export function daily_list_rate (data) {
    return request({
        url: 'statistics/daily_list_rate',
        method: 'get',
        params: data
    })
}
// http://192.168.1.199:5000/admin/statistics/renew_sum?start_month=2023-05&end_month=2023-05
//统计页增加续费率接口
export function renew_sum (data) {
    return request({
        url: 'statistics/renew_sum',
        method: 'get',
        params: data
    })
}

export function order_list (data) {
    return request({
        url: 'statistics/order_list',
        method: 'get',
        params: data
    })
}

export function count_top_three (data) {
    return request({
        url: 'statistics/order_money_count',
        method: 'get',
        params: data
    })
}

export function pay_time_order (data) {
    return request({
        url: 'statistics/pay_time_order',
        method: 'get',
        params: data
    })
}


export function money_order (data) {
    return request({
        url: 'statistics/money_order',
        method: 'get',
        params: data
    })
}
export function after_order_count (data) {
    return request({
        url: 'statistics/after_order_count',
        method: 'get',
        params: data
    })
}
// 获取客源统计
export function getCustomerSourceCount (data) {
    return request({
        url: 'statistics/customer_source_count',
        method: 'get',
        params: data
    })
}
// 获取系统订单统计
export function getCustomerSysCount (data) {
    return request({
        url: 'statistics/customer_sys_count',
        method: 'get',
        params: data
    })
}


